import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import type { TStickyMobile } from './models';

export const StickyMobile: FC<TStickyMobile> = ({
    Sticky,
    Aligner,
    BackgroundV2,
    X5BankButton,
    TextHolder,
    elLocation = 'partly',
    targetSelectors = [],
    targetSelectorsForHide = ['#form'],
    position = 'bottom',
    backgroundColor = '#fff',
    buttonText = 'Заказать карту',
    buttonHref = '#form',
    buttonView = 'primary',
    styles,
}) => {
    return (
        <Sticky
            className={cn(styles.external, styles.animation)}
            dataTestId="sticky-button-form"
            elLocation={elLocation}
            position={position}
            targetSelectors={targetSelectors}
            targetSelectorsForHide={targetSelectorsForHide}
        >
            <BackgroundV2 color={backgroundColor}>
                <Aligner styler={{ padding: 16 }}>
                    <X5BankButton block href={buttonHref} size="s" view={buttonView}>
                        <TextHolder text={buttonText} />
                    </X5BankButton>
                </Aligner>
            </BackgroundV2>
        </Sticky>
    );
};
